function updateHeaderClass() {
    const headerWrapper = document.querySelector('.header__wrapper');
    if (window.innerWidth >= 1366) {
        headerWrapper.classList.remove('js__show__mobile');
    } else {
        headerWrapper.classList.add('js__show__mobile'); // Optional: Add it back if the screen becomes smaller.
    }
}

// Run the function on page load and whenever the window is resized.
window.addEventListener('load', updateHeaderClass);
window.addEventListener('resize', updateHeaderClass);





